/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Projects_Bulk_Favorite_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to add {count} project(s) to favorites" |
*
* @param {Projects_Bulk_Favorite_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_bulk_favorite_error = /** @type {((inputs: Projects_Bulk_Favorite_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Bulk_Favorite_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Projekt(e) konnten nicht zu Favoriten hinzugefügt werden`)
	return /** @type {LocalizedString} */ (`Failed to add ${i?.count} project(s) to favorites`)
});